import * as Yup from "yup";

export const initialRowValues = Yup.object({
    taxApply: []
})

export const validationSchema = Yup.object({
    rateName: Yup
        .string()
        .required("Required"),
    description: Yup
        .string()
        .required("Required"),
    taxPercentage: Yup
        .number()
        .typeError("Number Only")
        .required("Required"),

})

export const initialValues = {
    rateName: "",
    description: "",
    taxPercentage: "",

    taxApply: [],
    status: true,
    rows: [initialRowValues],

}